import type {ReactElement} from 'react';
import React from 'react';

interface DownloadPanelErrorSectionProps {
  errorMessage: string;
}
export function DownloadPanelErrorSection({...props}: DownloadPanelErrorSectionProps): ReactElement {
  return <div className={`_full-width content-body _full-height spacing-p-t-3 spacing-p-b-3 spacing-p-r-4 spacing-p-l-4`}>{props.errorMessage}</div>;
}
